<template>
    <div>
        <div class="top-text">
            <van-sticky>
                <van-nav-bar @click-left="handelBack" :border="false">
                    <template #title>
                        <span :class="{ ug: language == 'ug' }">{{ $t('游戏说明') }}</span>
                    </template>
                    <template #left>
                        <img src="@/assets/icon_back.png" alt="" />
                    </template>
                </van-nav-bar>
            </van-sticky>
        </div>
        <div class="container">
            <p :class="['rule-item', language]">{{ $t('1. 用户加入竞技游戏每局游戏都需要扣除相应的游戏币。') }}</p>
            <p :class="['rule-item', language]">{{ $t('2. 因网络、手机设备、用户自动退出等原因，游戏中途退出游戏，不退还游戏币。') }}</p>
            <p :class="['rule-item', language]">{{ $t('3. 游戏结束，根据游戏奖励对应的游戏币。') }}</p>
            <p :class="['rule-item', language]">{{ $t('4. 游戏奖励明细如下：') }}</p>
            <div v-for="value in rewardRules" :key="value.name">
                <p :class="['games-name', language]">{{ value.name }}</p>
                <div v-for="item in value.rewards" :key="item.people" class="people_count">
                    <p style="text-indent: 1em;" class="games-people">{{ $t('参与人数：') + $t('xx人', {count: item.people}) }}</p>
                    <p style="text-indent: 2em;" class="games-rank" v-for="(reward, index) in item.reward" :key="index">{{ $t(`第xx名 奖励xx游戏币`, {count: index + 1, amount: reward}) }}</p>
                </div>
            </div>
            <p :class="['rule-item', language]">{{ $t('5. 游戏最终解释权归平台所有。') }}</p>
        </div>
    </div>
</template>

<script>
import { appFunc_callExit } from '@/utils/bridge'
import { getGameConfig } from '@/api'

export default {
    data() {
        return {
            language: 'ug',
            rewardRules: []
        }
    },
    methods: {
        getLanguage(language) {
            this.$i18n.locale = language
        },
        handelBack() {
            appFunc_callExit()
        },
        getGameConfig() {
            getGameConfig(3).then(res => {
                if(res.code === 1001 && res.data) {
                    res.data.map(item => {
                        const obj = {} 
                        obj.name = this.language ? item.nameUig : item.name
                        obj.rewards = item.newReward ? JSON.parse(item.newReward)?.vos : []
                        this.rewardRules.push(obj)
                    })
                    console.log(this.rewardRules);
                }
            })
        }
    },
    created() {
        const data = this.$route.query.language || 'ug'
        this.language = data
        this.getLanguage(data)
        this.getGameConfig()
    }
}
</script>

<style lang="scss" scoped>
.top-text {
    position: fixed;
    width: 375px;
    height: 44px;
    z-index: 9;
    top: 0px;
    border-bottom: 1px solid #F2F2F6;
}

::v-deep .van-nav-bar__content {
    height: 44px;

    .van-nav-bar__lef {
        padding: 10px !important;
    }
}

.van-nav-bar__left img {
    width: 30px;
    height: 30px;
}

.van-nav-bar__title span {
    font-family: 'UKIJCJK';
    font-size: 18px;
}

.van-nav-bar__right span {
    font-size: 16px;
}

.container {
    height: 100vh;
    padding: 60px 14px 0;
    box-sizing: border-box;

    .rule-item {
        font-weight: 500;
        font-size: 14px;
        color: #181818;
        line-height: 24px;
        padding-bottom: 12px;
    }

    .games-name {
        font-weight: 500;
        font-size: 12px;
        color: #333333;
        line-height: 24px;
        padding-bottom: 2px;
    }

    .games-rank {
        font-weight: 400;
        font-size: 12px;
        color: #5C5C5C;
        line-height: 24px;
        padding-bottom: 2px;
    }
}
</style>